import { SnapshotResponse } from '../../api-models';
import { Snapshot } from '../../types/core.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class GetAllSnapshots extends BaseAdapter<SnapshotResponse[]> implements AdapterInterface {
  rawResponse: SnapshotResponse[];

  async adaptResponse(): Promise<Snapshot[]> {
    await this.fetchApiResponse('/api/all-snapshots', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): Snapshot[] {
    return this.rawResponse.map((snapshot) => ({
      rawSnapshot: snapshot.snapshot,
      formattedSnapshot: snapshot.formatted_snapshot,
    }));
  }
}
